
import {Button, Space, Input, MenuProps, Popconfirm, Dropdown, message, Popover, Tooltip} from "antd";
import React, {forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState} from "react";
import Editor, { TEditorRef } from "@/components/EditorV2";
import {noteServer} from "@/common/notesServer";
import style from "./index.module.less";
import { confirmServer } from '@/common/confirmServer'

import { showLoad, hideLoad } from "@/common/loadServer";
import { atom, useAtom } from "jotai";

import { FullScreen, ShowEditor, closeEditor, pdfAtom } from '@/state';
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {
  ELEMENT_POPOVER_TOOLS_OFFSET_Y,
  EVENT_CANVAS_REFRESH_ELEMENT_COUNT,
  EVENT_CARD_BLOCK_JUMP,
  EVENT_CARD_CLOSED,
  EVENT_COPY_DOC_NOTE,
  EVENT_DELETE_ELEMENT_BY_ID,
  EVENT_DELETE_HTML_NOTE,
  EVENT_FAVIRIATE_CHANGE,
  EVENT_NOTE_DELETE,
  EVENT_NOTE_ON_SLIDER_RIGHT,
  EVENT_NOTE_READONLY_STATUS,
  EVENT_OPEN_LIBRARY_ITEM,
  EVENT_PDF_ON_SLIDER_RIGHT,
  EVENT_REFRESH_LIBRARY_LIST,
  EVENT_REFRESH_RECENTS,
  EVENT_REFRESH_TAG_LSIT,
  EVENT_RESET_NOTE_DATA,
  EVENT_SET_NOTE_DATA,
  EVENT_UPDATE_NOTE,
  FROM_DIALOG,
  FROM_HOME_LIBRARY,
  FROM_LIBRARY,
  FROM_PAGE_CARD,
  FROM_TAG,
  KEY_FILE_DIR,
  KEY_HAS_SHOWED_NOTE_SLIDER_TIPS,
  KEY_ISCTRL_CMD_PRESSED,
  KEY_QUICKNOTE_CONFIG,
  LASTEST_NOTE_DOC,
  MENU_SEPARATOR
} from "@/Const";
import Global from "@/global";
import {
  createCopyLink,
  generateRandomPageKey, generateUUID2, getCtrlOrAlt, getImagePathSvg,
  getImagePathWithTheme, getImagePathWithThemeSvg, getIntValue,
  getItem,
  imgPathPerfix, isArray, isCardEmpty, isDarkMode, isInDraw,
  isStringNullOrEmpty, logger,
  MenuItem, replaceNoteNameFromElementHtml
} from "@/utils";
import {useTranslation} from "react-i18next";
import {APP_WEB} from "@/electron_interactive";
import TitleBar from "@/TitleBar";
import global from "@/global";
import {isMobile} from "react-device-detect";
import {TNote} from "@/index";
import {editDoc} from "@model/doc";
import {ipcInvoke, ipcOn, ipcRemove, ipcSend} from "@/common/ipc";
import {t} from "i18next";
import {getCardById, updateCard, updateCardViewTime} from "@model/card";
import {deleteAllCardFromRefProject, getProjectById} from "@model/note";
import {getCardPath, getCardTitle, getFavorChildrenMenu, isInSingleFloatWindow, updateFavorToFolder} from "@/Utility";
import {useNavigate} from "react-router-dom";
import {
  IconAddToFavor,
  IconAddToProject,
  IconCopyLink, IconDelete,
  IconInfoMenu,
  IconMakeCopy,
  IconManagerTags,
  IconMenuExportItem, IconRemoveFavor,
  IconRename,
  IconSearch, IconVersionHistory
} from "@/Icon";
import SideBarFold from "@/components/EditorV2/SideBarFold/SideBarFold";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {shareCardData} from "@/views/Utils/CardUtils";
import {serializeProseMirrorToMarkdown} from "@/components/EditorV2/markdownSerializer";


/** 笔记操作 */
enum ENoteAction {
  /** 重命名 */
  rename,
  /** 收藏 */
  addToFavorite,
  /** 复制 */
  makeACopy,
  /** 删除 */
  delete,
  /** 恢复 */
  restore,
  /** 永久删除 */
  permancentlyDelete,
  /** 搜索 */
  search,
  viewHistory
}

let mTimerId:any = 0;

const NewNote = forwardRef((props:{propData?:any,eventSliderClickCallback:any,onHeaderMouseDown?:any,onHeaderMouseMove?:any,onHeaderMouseUp?:any,onRef?:any,dialogSize?:any,onPinSet?:any}, ref) => {
  useImperativeHandle(ref,()=>({
    getIsPin:getIsPin,
    refreshTitleHeight:refreshTitleHeight,
  }))
  const {t} = useTranslation();
  // const [name, setName] = useState("");
  const editorRef = useRef<TEditorRef>();
  const [data, setData] = useState<any>();
  const [editor,setEditor] = useState(null);
  const [sideBarStatus, setSideBarStatus] = useState<any>(0);
  const sideBarFoldRef = useRef(null);
  const [isPin,setIsPin] = useState(false);
  const currentActivityElement = useRef<any>(null);
  const [isShowMenuMore,setIsShowMenuMore] = useState(false);
  const [isShowMenuMore1,setIsShowMenuMore1] = useState(false);
  const [isSaveEnable,setIsSaveEnable] = useState(false);
  const [isOpenSaveTooltip,setIsOpenSaveTooltip] = useState(false);

  const [,updateState] = useState();
  const forceUpdate = React.useCallback(()=>updateState({}),[]);
  const mSelfGUID = useRef(crypto.randomUUID());
  const mEditorRef = useRef(null);

  const detectNodeTypeArr = ['taskList', 'bulletList', 'orderedList']

  // const navigate = useNavigate();
  // const params = useParams();
  const navigate00000000000 = () => {
    closeEditor()
  }
  const items: MenuProps['items'] = [
    {
      label: t("Rename"),
      key: ENoteAction.rename,
      // icon: <IconNoteRename/>
    },
    // {
    //   label: data?.isFavirated ? '取消收藏' : '收藏',
    //   key: ENoteAction.addToFavorite,
    //   // icon: <StarOutlined />
    //   icon: <IconAddToFavor />
    // },
    {
      label: t("Generic copy"),
      key: ENoteAction.makeACopy,
      // icon: <IconNoteMakeCopy/>
    },
    {
      label: t("Search"),
      key: ENoteAction.search,
      // icon: <IconNoteSearch1/>
    },
    {
      label: t("Delete"),
      key: ENoteAction.delete,
      // icon: <IconNoteDelete/>
    },


  ];
  const itemsPresentMode: MenuProps['items'] = [
    {
      label: t("Search"),
      key: ENoteAction.search,
      // icon: <IconNoteSearch1/>
    },
  ];

  const getIsPin = ()=>{
    return isPin;
  }

  const refreshTitleHeight = ()=>{
    editorRef.current?.refreshTitleHeight();
  }

  //分享菜单
  const MENU_MORE= ()=>{
    const arrayMenus = [
      getItem(t("ExportPDF"), 'exportPdf', <IconMenuExportItem/>, undefined, undefined, async () => {

        const data = await getSaveData()
        const name = getCardTitle(data);

        //保存到doc
        editDoc((data.id || LASTEST_NOTE_DOC),data.doc,data.name).then(res=>{
          setTimeout(() => {
            ipcSend('save-pdf-to-system', (data.id || LASTEST_NOTE_DOC), name)
          }, 10);
        })
      }),
      getItem(t("ExportMarkdown"), 'exportMarkdown', <IconMenuExportItem/>, undefined, undefined, async () => {
        markdown()
      }),
      getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

      }),
      // getItem(t("ShowInfo"), 'showInfo', null, undefined, undefined, () => {
      //   window.GOpenCountWords();
      // }),
      getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, () => {
        // @ts-ignore
        handleMenuClick({key:ENoteAction.rename})
      }),
      getItem(data?.isFavirated === 1?t('Cancel favor'):t("Add to Favorites"), 'favor', data?.isFavirated === 1?<IconRemoveFavor/>:<IconAddToFavor/>, getFavorChildrenMenu(data?.isFavirated,async (key)=>{
        const ccccccc:any = await editorRef.current?.save?.();
        const iiittteeem = {
          ...ccccccc,
          type: ccccccc.type || 'card',
          favirateTime:Date.now(),
          isFavirated: (data?.isFavirated == 1) ? 0 : 1
        }
        await updateFavorToFolder(key,iiittteeem);
        await updateCard(iiittteeem).then(res=>{
          postMessage(EVENT_FAVIRIATE_CHANGE);
        });
        const card = await getCardById(data?.id, true);
        setData(card);
      }), undefined, async () => {
        const ccccccc = await editorRef.current?.save?.();
        await updateCard({
          ...ccccccc,
          type: ccccccc.type || 'card',
          favirateTime:Date.now(),
          isFavirated: (data?.isFavirated == 1) ? 0 : 1
        }).then(res=>{
          postMessage(EVENT_FAVIRIATE_CHANGE);
        });
        const card = await getCardById(data?.id, true);
        setData(card);
      }),
      getItem(t("Generic copy"), 'makeCopy', <IconMakeCopy/>, undefined, undefined, async () => {
        // @ts-ignore
        handleMenuClick({key:ENoteAction.makeACopy})
      }),
      getItem(t("Search"), 'search', <IconSearch/>, undefined, undefined, () => {
// @ts-ignore
        handleMenuClick({key:ENoteAction.search})
      }),
      getItem(t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, async () => {
        const saveData:any = await getSaveData();
        data.doc = saveData.doc;
        data.name = saveData.name;
        data.type = saveData.type || 'card';
        if (!data.name){
          data.name = t("Untitled");
        }
        if (!data.createTime){
          data.createTime = Date.now();
          data.updateTime = Date.now();
        }
        window.showInfo('library',data)
      }),

      getItem(<div>{t("Version history")}<label className={'beta'}>{'Beta'}</label></div>, 'versionHistory',
          <IconVersionHistory/>, undefined, undefined, () => {
// @ts-ignore
            handleMenuClick({key: ENoteAction.viewHistory})
          }),

      getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

      }),

      getItem(t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
        createCopyLink('library',data.id,null,null);
      }),
      getItem(t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, async () => {
        //如果是新建的card,操作标签前先保存这个card
        let card:any = await getCardById(data.id,false);
        let ddddddatatataat = data;

        if (!card){
          // logger('save as a new card....');
          const ccccccc =  await editorRef.current?.save?.();
          await updateCard({
            ...ccccccc,
            type:ccccccc.type || 'card'
          },true,true,'fromManageTag');
          card = await getCardById(data.id,true);
          setData(card);
          ddddddatatataat = card;
          global.g_currentNoteData = card;
        }
        window.showManageTags([ddddddatatataat]);
      }),

      getItem(t("Add to project"), 'addToProject', <IconAddToProject/>, undefined, undefined, async () => {
        const ccccccc:any = await editorRef.current?.save?.();
        await updateCard({
          ...ccccccc,
          type: ccccccc.type || 'card',
          isFavirated: (data.isFavirated == 1) ? 0 : 1
        })
        const card:any = await getCardById(data.id, true);
        setData(card);
        window.showDialogChooseProject([card])
      }),

      getItem(t("Delete"), 'delete', <IconDelete/>, undefined, undefined, () => {
        // @ts-ignore
        handleMenuClick({key:ENoteAction.delete})
      }),
    ];

    if (props.propData?.type == 'journal'){
      for (let i=arrayMenus.length -1;i>=0;i--){
        const item:any = arrayMenus[i];
        if (item.key == 'rename' || item.key == 'makeCopy' || item.key == 'delete' || item.key == 'favor'){
          arrayMenus.splice(i,1);
        }
      }
    }

    return arrayMenus;
  }

  const params = {id: sessionStorage.getItem('note-id')}
  const [isPresentMode, setIsPresentMode] = useState(APP_WEB ? true : false);
  const [arrayMenuMore, setArrayMenuMore] = useState(items);
  const [isShowSliderTooltip,setIsShowSliderTooltip] = useState(false);

  const [isPdfAtom] = useAtom(pdfAtom)
  const [fullScreen, setFullScreen] = useAtom(FullScreen)

  const handleMenuClick: MenuProps['onClick'] = async (e: any) => {
    const key: ENoteAction = +e.key as ENoteAction
    switch (key) {
      case ENoteAction.restore:
        noteServer.restore(data.id)
        break;
      case ENoteAction.addToFavorite:
        const data3: TNote = await getSaveData() as TNote
        const dataFavirate = noteServer.favitateNote(data3.id)
        if (dataFavirate.isFavirated) {
          noteServer.openTip('success', '该笔记已收藏')
        } else {
          noteServer.openTip('success', '该笔记已取消收藏')
        }
        if (params.id) {
          // updateData()
        } else {
          navigate00000000000('/editNote/' + dataFavirate.id, {replace: true})
        }
        break;
      case ENoteAction.makeACopy:
        // const data2: TNote = await getSaveData() as TNote
        // const copyData = noteServer.copy(data2.id, false)
        // navigate('/editNote/' + copyData.id, { replace: true })
        const noteSimpleData:any = await getSaveData();
        const newData = {...noteSimpleData};
        newData.id = generateUUID2();
        newData.name += `(${t('Copy')})`
        delete newData.viewTime;
        await updateCard(newData);
        // window.globalRefreshList();//全部刷新...
        // postMessage(EVENT_COPY_DOC_NOTE, noteSimpleData);
        message.info(t("Duplicated"));
        window.globalRefreshList('refresh_single_library_item_',newData.id);
        break;
      case ENoteAction.rename:
        editorRef.current?.rename?.()
        break;
      case ENoteAction.delete:
        if (global.g_dialogNoteFrom == FROM_HOME_LIBRARY || global.g_dialogNoteFrom == FROM_TAG){//这里也是，在不同的地方删，显示一样的东西。本身都是同一个删除
          window.showMessageBox(t("Tips"),t("ConfirmDeleteLibraryItem").replace('{0}','card'),t("Cancel"),t("Delete"),null,async ()=>{
            const card = await getCardById(data.id);
            if (card){
              card.isDeleted = 1;
              card.deleteTime = Date.now();
              await updateCard(card);
              //删除这个card所关联的项目
              await deleteAllCardFromRefProject(card);
              setData(card);//为了更新editorv2/index下的data
              //更新.
              // postMessage(EVENT_REFRESH_LIBRARY_LIST);
              setTimeout(()=>{
                closeEditor(data);
              },160)
              //删除当前界面上的.
              postMessage(EVENT_DELETE_HTML_NOTE,{id:data.id});
              postMessage(EVENT_REFRESH_TAG_LSIT);
            }else{
              data.isDeleted = 1;
              data.deleteTime = Date.now();
              postMessage(EVENT_REFRESH_LIBRARY_LIST);
              setTimeout(()=>{
                closeEditor(data);
              },160)
              //删除当前界面上的.
              postMessage(EVENT_DELETE_HTML_NOTE,{id:data.id})
              postMessage(EVENT_REFRESH_TAG_LSIT);
            }
          })
        }else{
          window.showMessageBox(t("Tips"),t("DeleteCardTips"),t("Cancel"),t("Delete"), null,async ()=>{
            if (params.id) {
              // noteServer.deleteNote(data.id)
            } else {

            }
            const card = await getCardById(data.id);
            if (card) {
              card.isDeleted = 1;
              card.deleteTime = Date.now();
              await updateCard(card);
            }

            postMessage(EVENT_DELETE_HTML_NOTE, {id: data.id});
            postMessage(EVENT_REFRESH_TAG_LSIT);
            closeEditor(data);
          })
        }
        break;
      case ENoteAction.search:
        window.GSearchOpen?.()
        break;
      case ENoteAction.viewHistory:
        const data11111:any = await editorRef.current?.save?.();

        if (isStringNullOrEmpty(data11111.id)) {
          data11111.id = generateRandomPageKey();
        }
        updateCard(data11111);
        closeEditor();
        window.showDialogCardHistory(data.id,(newData)=>{
          setData(newData)
        });

        break;
    }
  };

  /**
   * markdown
   */
  async function markdown(){
    // window.showProgress(t("Exporting"))

    const noteSimpleData:any = await getSaveData();
    // const name = getCardTitle(noteSimpleData);
    /*
    mEditorRef.current?.chain().export({
      format: 'md',
      onExport(context) {
        const { blob, error } = context
        if(error){
          noteServer.openTip("error", t("ExportMarkdownFail"));
          return;
        }
        blob.arrayBuffer().then(arrayBuffer => {
          window.closeProgress();

          ipcSend('save-markdown-to-system', arrayBuffer, name)
        });
        // context.download()  该API存在不能自定义 导出文件名的缺陷
      },
    })*/
    window.exportMarkdown(noteSimpleData);
  }

  async function getSaveData() {
    window.GSearchClose?.()
    showLoad()
    const data = await editorRef.current?.save?.();
    // const ret = noteServer[params.id ? "edit" : "add"]({
    //   ...data,
    // } as TNote);
    hideLoad()
    return data
  }

  const menuProps = {
    items: arrayMenuMore,
    onClick: handleMenuClick,
  };


  // function updateData() {
  //   if (params.id) {
  //     global.g_currentRecentId = params.id;
  //     //更新查看时间
  //     // updateCardViewTime(params.id).then(res=>{
  //     //   postMessage(EVENT_REFRESH_RECENTS);
  //     // })
  //
  //     setData({
  //       ...Global.g_currentNoteData
  //     })
  //
  //     if (Global.g_currentNoteFullScreen){
  //       setFullScreen(true);
  //
  //       setTimeout(()=>{
  //         Global.g_currentNoteFullScreen = false;
  //       },2000)
  //     }
  //   }
  // }
  //
  // useEffect(()=>{
  //   updateData();
  // }, [params.id]);

  useEffect(()=>{
    if (isInSingleFloatWindow()){
      //独立的浮窗card...
      const id = 'card_float_win_cache';
      getCardById(id).then(res=>{
        if (!res){
          res = {
            id:id,
            createTime:Date.now(),
            type:'card',
            isDeleted:2,//作为不可见的.
            updateTime:Date.now(),
            doc:''
          }
        }
        setIsSaveEnable(!isCardEmpty(res.doc));
        setData(res);
      })
    }else{
      const newData = {...props.propData};
      if (!newData.createTime){
        newData.createTime = Date.now();
      }
      if (!newData.type){
        newData.type = 'card';
      }
      setData(newData);
    }

    setTimeout(async () => {
      const blockId = sessionStorage.getItem('block-id')
      const blockType = sessionStorage.getItem('block-type')
      const ifFullScreen = sessionStorage.getItem('ifFullScreen')
      if (blockId && blockType) {
        await sleep(200)
        sessionStorage.removeItem('block-id')
        sessionStorage.removeItem('block-type')
        sessionStorage.removeItem('ifFullScreen')
        // 全屏
        if(ifFullScreen==='true')setFullScreen(true)
        await sleep(200)
        if (blockType === 'highlight') {
          const boundingNode = mEditorRef.current?.view.dom.querySelectorAll(`[data-id="${blockId}"]`)[0]
          const boundingRect = boundingNode.getBoundingClientRect();
          const scrollTop = mEditorRef.current?.view.dom.parentElement.parentElement.parentElement.scrollTop;
          const clientHeight = document.documentElement.clientHeight;
          const targetScroll = scrollTop + boundingRect.top - clientHeight / 2;
          mEditorRef.current?.view.dom.parentElement.parentElement.parentElement.scrollTo({
            top: targetScroll,
            behavior: 'smooth' // 平滑滚动
          });
          const markRes = getMarkById(blockId)
          await sleep(800)
          mEditorRef.current?.chain().focus().setTextSelection({ from: markRes?.pos, to: markRes?.end }).run()

        }else if (blockType === "deeplink") {
          const selectedNP = window.GEditor.$doc.querySelectorAll("deeplink", {
            id: blockId,
          })[0];
          if (selectedNP) {
            mEditorRef.current?.chain()
                .focus()
                .setNodeSelection(selectedNP.pos - 1)
                .run();
            const coords = mEditorRef.current?.view.coordsAtPos(selectedNP.pos - 1);
            const scrollContainer =
                mEditorRef.current?.view.dom.parentElement.parentElement.parentElement;
            const scrollTop = scrollContainer.scrollTop;
            const clientHeight = document.documentElement.clientHeight;
            scrollContainer.scrollTo({
              top: scrollTop + coords.top - clientHeight / 2,
              behavior: "smooth",
            });
          }
        }
        else {
          const selectedNP = mEditorRef.current?.$doc.querySelectorAll(blockType, { id: blockId })[0];
          if (selectedNP){
            mEditorRef.current?.chain().focus().setNodeSelection(selectedNP.pos - 1).scrollIntoView().run();
          }
        }
      }
    }, 600)

  },[props.propData])

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /**
   * 按键
   * @param event
   */
  function onKeyDown(event:any){
    // debugLog('keydown',event);

    let szKey = event.key.toLowerCase();
    if ((event.metaKey || event.ctrlKey)){
      if (szKey == KEYS.F){
        handleMenuClick({key: ENoteAction.search})
      }else if (szKey == KEYS.S){
        sideBarFoldRef.current?.onToggleBar();
      }
    }else if (szKey == KEYS.ESCAPE.toLowerCase()){
      window.closePopupCardList();
    }
  }

  useEffect(() => {
    document.body.addEventListener('keydown',onKeyDown);

    return ()=>{
      document.body.removeEventListener('keydown',onKeyDown);
    }
  });

  useEffect(() => {
    setIsPin(props.propData?.isPin);
    if (localStorage.getItem(KEY_ISCTRL_CMD_PRESSED) == 'true'){//侧边栏按住ctrl来的。。。
      global.g_isCtrlPressed = true;
      setTimeout(()=>{
        global.g_isCtrlPressed = false;
      },1000)
    }


    if (global.g_isCtrlPressed){
      setIsPin(true);
    }

    setIsPresentMode(global.g_isPresentMode);
    if (global.g_isPresentMode) {
      setArrayMenuMore(itemsPresentMode)
    } else {
      setArrayMenuMore(items);
    }

    setIsShowSliderTooltip(localStorage.getItem(KEY_HAS_SHOWED_NOTE_SLIDER_TIPS) != 'true');

    recvMessage(EVENT_RESET_NOTE_DATA,(msg,data)=>{
      // logger('EVENT_RESET_NOTE_DATA');
      // logger(data.data?.card);
      setData({
        ...data.data.card
      })
      if (Global.g_currentNoteFullScreen){
        setFullScreen(true);
        Global.g_currentNoteFullScreen = false;
      }

      setTimeout(async () => {
        const blockId = sessionStorage.getItem("block-id");
        const blockType = sessionStorage.getItem("block-type");
        if (blockId && blockType) {
          await sleep(200);
          sessionStorage.removeItem("block-id");
          sessionStorage.removeItem("block-type");
          sessionStorage.removeItem("ifFullScreen");
          window.isHeadingTreeSelection = true;
          if (blockType === "deeplink") {
            const selectedNP = editorRef.current?.$doc.querySelectorAll("deeplink", {
              id: blockId,
            })[0];
            if (selectedNP) {
              editorRef.current?.chain()
                  .focus()
                  .setNodeSelection(selectedNP.pos - 1)
                  .run();
              const coords = editorRef.current?.view.coordsAtPos(selectedNP.pos - 1);
              const scrollContainer =
                  editorRef.current?.view.dom.parentElement.parentElement.parentElement;
              const scrollTop = scrollContainer.scrollTop;
              const clientHeight = document.documentElement.clientHeight;
              scrollContainer.scrollTo({
                top: scrollTop + coords.top - clientHeight / 2,
                behavior: "smooth",
              });
            }
          } else if (blockType === "highlight") {
            const boundingNode = editorRef.current?.view.dom.querySelectorAll(
                `[data-id="${blockId}"]`
            )[0];
            if (boundingNode) {
              const boundingRect = boundingNode.getBoundingClientRect();
              const scrollTop =
                  editorRef.current?.view.dom.parentElement.parentElement.parentElement
                      .scrollTop;
              const clientHeight = document.documentElement.clientHeight;
              const targetScroll = scrollTop + boundingRect.top - clientHeight / 2;
              editorRef.current?.view.dom.parentElement.parentElement.parentElement.scrollTo(
                  {
                    top: targetScroll,
                    behavior: "smooth",
                  }
              );
              const markRes = getMarkById(blockId);
              await sleep(800);
              editorRef.current?.chain()
                  .focus()
                  .setTextSelection({ from: markRes?.pos, to: markRes?.end })
                  .run();
            }
          } else {
            const selectedNP = editorRef.current?.$doc.querySelectorAll(blockType, {
              id: blockId,
            })[0];
            if (selectedNP) {
              editorRef.current?.chain()
                  .focus()
                  .setNodeSelection(selectedNP.from - 1)
                  .scrollIntoView()
                  .run();
            }
          }
        }
      }, 500);
    })

    recvMessage(EVENT_CARD_BLOCK_JUMP,(msg,data)=>{
      setTimeout(async ()=>{
        const blockId= data.data.childId;// sessionStorage.getItem('block-id')
        const blockType=data.data.elementType;// sessionStorage.getItem('block-type')

        if(blockId && blockType){
          sessionStorage.removeItem('block-id')
          sessionStorage.removeItem('block-type')
          const selectedNP = mEditorRef.current?.$doc.querySelectorAll(blockType,{id:blockId})[0]
          mEditorRef.current?.chain().focus().setNodeSelection(selectedNP.pos-1).scrollIntoView({ block: 'start' }).run();
          mEditorRef.current?.chain().focus()
              .setTextSelection({
                from: mEditorRef.current?.state.selection.from,
                to: selectedNP.to
              })
              .run()
        }
      },300)
    })

    global.g_showDialogs['dialogCard'] = true;

    window.refreshList['updateTheme_notev2_'+mSelfGUID.current] = forceUpdate;

    // mTimerId = setInterval(() => {
    //   console.log('***AUTO SAVE NOTE....')
    //   window.GNoteSave?.(false, false,false,true);
    // }, 30000)
    return () => {
      unSubscribe(EVENT_RESET_NOTE_DATA);
      unSubscribe(EVENT_CARD_BLOCK_JUMP);
      // clearInterval(mTimerId);
      //这里检测一下当前html中的图片，
      global.g_showDialogs['dialogCard'] = false;
      global.g_isNewCardInDrawFromC = false;
      delete window.refreshList['updateTheme_notev2_'+mSelfGUID.current];
      ipcInvoke('update-backup-time');
    }
  }, [])

  useEffect(() => {
    if (isPin){
      if (global.g_isHiddenAllFloatWin){
        //有隐藏的
        window.visibleAllFloatWin();
      }

      setIsShowSliderTooltip(false);
    }
  }, [isPin]);

  useEffect(() => {
    ipcOn('float-window-focus',onWindowFocus)
    return ()=>{
      ipcRemove('float-window-focus',onWindowFocus);
    }
  }, [editorRef.current]);

  /**
   * 独立的窗口获取焦点的时候....
   */
  function onWindowFocus(){
    editorRef.current?.onEditorFocus();
  }

  const getMarkById = (targetId) => {
    let content = []
    mEditorRef.current?.state?.doc?.descendants((node, pos) => {
      if (node.attrs?.highlightImgUrl) {
        content.push({
          listId: crypto.randomUUID(),
          type: node.type.name,
          color: '#ffd400',
          content: node.attrs?.highlightImgUrl,
          pos: pos, //即start
          end: pos + node.nodeSize,
          id: node.attrs?.id, //生成唯一性link
          selectStatus: false,
          editStatus: false,
          noteText: node.attrs?.noteText, // 笔记,
          node: node,
        })
        return
      }
      if (node.attrs?.blockHighlight) {
        // 块内容默认必然是黄色的
        content.push({
          listId: crypto.randomUUID(),
          type: node.type.name,
          color: '#ffd400',
          content: node.textContent,
          pos: pos, //即start
          end: pos + node.nodeSize,
          id: node.attrs?.id, //生成唯一性link
          node: node,
          selectStatus: false,
          editStatus: false,
          noteText: node.attrs?.noteText, // 笔记,
        })
        return
      }
      if (getHighlightRelation(pos)) {
        return;
      }


      node?.marks.forEach(mark => {
        if (mark.type.name === 'highlight') {
          // 连续mark合并
          if (mark.attrs?.id === content.at(-1)?.id) {
            content[content.length - 1].content = `${content[content.length - 1].content}\n${node.text}`
            content[content.length - 1].end = pos + node.text.length
          } else {
            content.push({
              listId: crypto.randomUUID(),
              type: 'text',
              color: mark.attrs?.color,
              content: node.text,
              pos: pos, //即start
              end: pos + node.text.length,
              id: mark.attrs?.id, //生成唯一性link
              selectStatus: false,
              noteText: mark.attrs?.noteText, // 笔记,
              editStatus: false,
              node: mark
            })
          }
        }
      })
    });
    content.filter(item => item.id === targetId)
    return content.filter(item => item.id === targetId)[0]
  }

  // 遍历拿到hightlight内容 暂时不处理block部分
  function getHighlightRelation(pos) {
    const resolvedPos = mEditorRef.current?.state.doc.resolve(pos);
    // 获取当前节点的父节点
    const parentNode = resolvedPos.node(resolvedPos.depth - 1);
    // 获取当前节点的祖父节点（如果存在的话）
    const grandNode = resolvedPos.node(resolvedPos.depth - 2);
    // 获取当前节点的曾祖父节点（如果存在的话）
    const greatGrandNode = resolvedPos.node(resolvedPos.depth - 3);
    if (detectNodeTypeArr.includes(parentNode?.type?.name) && parentNode.attrs.blockHighlight) {
      return true
    }
    if (detectNodeTypeArr.includes(grandNode?.type?.name) && grandNode.attrs.blockHighlight) {
      return true
    }
    if (detectNodeTypeArr.includes(greatGrandNode?.type?.name) && greatGrandNode.attrs.blockHighlight) {
      return true
    }
    return false;
  }

  const getEditorLRPadding = ()=>{
    if (props.dialogSize){
      const nWidth = getIntValue(props.dialogSize.width.replace('px',''),20);
      return nWidth/9.5 + 'px';
    }

    const divContainer = document.getElementById('card-dialog-'+data?.id);
    if (divContainer){
      const nW = divContainer.clientWidth;
      return nW/9.5 + 'px';
    }

    return '20px';
  }

  //全屏的填充...
  const getFullscreenEditorLRPadding = ()=>{
    //原来是固定386px;
    const nW = document.body.clientWidth;
    if (isInSingleFloatWindow()){
      return '10px'//nW/10 + 'px';
    }
    return nW/4 + 'px';
  }

  async function save(isInsertCanvas = false, isClose = true,isCloseSearch = true,isAutoSave=false) {
    if (global.g_isPresentMode) {
      closeEditor();
      return;
    };
    if(isCloseSearch){
      window.GSearchClose?.()
    }
    const data = await editorRef.current?.save?.();

    if (isStringNullOrEmpty(data.id)) {
      data.id = generateRandomPageKey();
      // logger('save note id is null???:'+data.id);
    }

    if (isClose) {
      closeEditor();
      postMessage(EVENT_CARD_CLOSED,{data, isInsertCanvas: isInsertCanvas});

      if (global.g_isNotePopupWindow){
        const divNoteContainer = document.getElementById('div-note-container');
        const fScrollRate = divNoteContainer?.scrollTop/divNoteContainer?.clientHeight;
        postMessage(EVENT_NOTE_ON_SLIDER_RIGHT, {data:data,scrollRate:fScrollRate});
        global.g_isNotePopupWindow = false;
      }
    }

    postMessage(EVENT_UPDATE_NOTE, {data, isInsertCanvas: isInsertCanvas,isAutoSave});

    //以下，各不同界面可能有的需要的数据....
    if (!isAutoSave && window.eventAddChooseCard){
      window.eventAddChooseCard(data);
      delete window.eventAddChooseCard;
    }
  }

  const patchMenuFavor = ()=>{
    setTimeout(()=>{
      const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
      for (let i=0;i<arrayMenus.length;i++){
        const item = arrayMenus[i];
        if (item.dataset?.menuId?.endsWith('-favor')){
          item.onclick = async function (event:any){
            const ccccccc = await editorRef.current?.save?.();
            const iiittteeem = {
              ...ccccccc,
              type: 'card',
              favirateTime:Date.now(),
              isFavirated: (data?.isFavirated == 1) ? 0 : 1
            }
            await updateCard(iiittteeem).then(res=>{
              postMessage(EVENT_FAVIRIATE_CHANGE);
            });
            const card = await getCardById(data?.id, true);
            setData(card);

            setIsShowMenuMore(false);
            setIsShowMenuMore1(false);
          }
        }
      }
    },100)
  }

  window.GNoteSave = save;

  return (
      <>
        {
            !fullScreen && !isMobile &&
            <div className={style.headModal} style={{background:'transparent'}} onMouseDown={(event)=>{
              if (props.onHeaderMouseDown) {
                props.onHeaderMouseDown(event);
              }
            }} onMouseMove={(event)=>{
              if (props.onHeaderMouseMove) {
                props.onHeaderMouseMove(event);
              }
            }} onMouseUp={(event)=>{
              if (props.onHeaderMouseUp) {
                props.onHeaderMouseUp(event);
              }
            }}>
              {/*<FullScreenOne theme="outline" size="24" fill="#333" onClick={() => setFullScreen(!fullScreen)} />*/}
              <img src={getImagePathWithTheme("dialog_full_screen_1111.svg")}
                   onClick={async (event) => {
                     event.stopPropagation();
                     window.closeDialogGlobalSearch();
                     // setFullScreen(!fullScreen);
                     closeEditor(data);
                     const newData:any = await editorRef.current?.save?.();
                     if (!newData.type) {//这里还有journal
                       newData.type = 'card';
                     }
                     updateCard(newData).then(res=>{
                       window.navigate(getCardPath(),{cardId:newData.id})
                     })
                   }}
                   className='title-icon hovered-gray-radius img-32 cursor-pointer ml-6'/>

              {/*//缩放到侧边栏*/}
              {
                  (window.location.href.includes("/draw") || window.location.href.includes("/defaultProject") || window.location.href.includes('/card') || window.location.href.includes('/journal')) &&
                  <Tooltip trigger={'click'} overlayStyle={{fontSize:'12px'}} title={t("ClickToSplitView")} placement={"bottom"} open={isShowSliderTooltip}>
                    <img className={'img-32 hovered-gray-radius ml-10 cursor-pointer'} src={getImagePathWithTheme('dialog_slider_right_1111.svg')}
                         onClick={async () => {
                           localStorage.setItem(KEY_HAS_SHOWED_NOTE_SLIDER_TIPS,'true');
                           setIsShowSliderTooltip(false);
                           if (props.eventSliderClickCallback) {
                             props.eventSliderClickCallback();
                           }
                           if (window.location.href.includes("/draw") || window.location.href.includes("/defaultProject")) {
                             const divNoteContainer = document.getElementById('div-note-container');
                             let fScrollRate:any = 0;
                             if (divNoteContainer) {
                               if (divNoteContainer.clientHeight) {
                                 fScrollRate = divNoteContainer?.scrollTop / divNoteContainer?.clientHeight;
                               }
                             }
                             const newData = await editorRef.current?.save?.();
                             postMessage(EVENT_NOTE_ON_SLIDER_RIGHT, {data: newData, scrollRate: fScrollRate});
                             //保存数据到左侧列表
                             postMessage(EVENT_UPDATE_NOTE, {data: newData, isInsertCanvas: false});
                             window.closeDialogCard(newData);
                           }else {
                             //这里要保存一下..
                             const data:any = await editorRef.current?.save?.();
                             if (isStringNullOrEmpty(data.id)) {
                               data.id = generateRandomPageKey();
                             }
                             if (!data.type){
                               data.type = 'card'
                             }
                             await updateCard(data);

                             //在全局侧栏打开
                             window.openRightSlider(data,data.type,{forceType:'library'});
                             window.closeDialogCard(props.propData);
                           }

                           // closeEditor();
                         }}/>
                  </Tooltip>
              }

              <Tooltip overlayClassName='font-size-12' zIndex={99999} title={
                <div>{t("Table of content")}<span className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + S")}</span></div>} arrow={false}>
                <img className='img-32 hovered-gray-radius ml-10' onClick={() => {
                  sideBarFoldRef.current?.onToggleBar();
                }} src={getImagePathWithTheme('dialog_table_of_content_1111.svg')}/>
              </Tooltip>

              <span style={{flexGrow: '1'}}></span>

              {
                //窗口模式的右上角....
                  !APP_WEB && !isPresentMode && !global.g_isPresentMode &&
                  <div style={{display: "flex", justifyContent: 'flex-end', alignItems: 'center'}}>
                    {
                        global.g_isNewCardInDrawFromC &&
                        <div className='flex-center text-color font-size-12 button-solid-style'
                             style={{padding: '0px 12px', height: '28px',color:'white'}}
                             onClick={() => {
                               save(true, true);
                               postMessage(EVENT_CANVAS_REFRESH_ELEMENT_COUNT);
                             }}>
                          <img className='img-12' src={getImagePathSvg('card_add_to_board.svg')}/>
                          <span className='ml-4'
                                style={{color: 'white'}}>{t('Add to board')}</span>
                        </div>
                    }

                    {
                      // isInDraw() &&
                      <Tooltip overlayClassName='font-size-12' title={isPin?t("UnpinFloatWindow"):t("PinAsFloatWindow")} zIndex={9999} arrow={false}>
                        <img className='img-32 hovered-gray-radius ml-4' onMouseDown={()=>{
                          // const focus = editorRef.current?.onGetFocus();
                          currentActivityElement.current = document.activeElement;
                        }} onClick={() => {

                            setIsPin(!isPin);
                            if (props.onPinSet) {
                              props.onPinSet(!isPin);
                            }

                            setTimeout(()=>{
                              if (currentActivityElement.current){
                                currentActivityElement.current.focus();
                              }
                            },100)

                        }} src={getImagePathWithTheme(isPin?'dialog_unpin.svg':'dialog_card_new_pin.svg')}/>
                      </Tooltip>
                    }


                    <Tooltip overlayClassName='font-size-12' title={t("Info")} zIndex={9999} arrow={false}>
                      <img className='img-32 hovered-gray-radius ml-4' onClick={async () => {
                        const dataCard:any = await editorRef.current?.save?.();

                        const newData = {...data};
                        if (!newData.updateTime) {
                          newData.updateTime = Date.now();
                        }
                        newData.doc = dataCard.doc;
                        newData.name = dataCard.name;
                        setData(newData);
                        window.showInfo('library',newData);
                      }} src={getImagePathWithTheme('dialog_card_new_info_1.svg')}/>
                    </Tooltip>

                    {/*分享 发布*/}
                    <Tooltip overlayClassName='font-size-12' title={t('Share1')} zIndex={9999} arrow={false}>
                      <img className='img-32 hovered-gray-radius ml-4' onMouseDown={()=>{
                        // const focus = editorRef.current?.onGetFocus();
                        currentActivityElement.current = document.activeElement;
                      }} onClick={() => {
                        window.showDialogPublishCardToWeb(data.id,async (szId,dialogPublishToWebRef)=>{
                          if (szId == 'exportPdf') {

                            const data:any = await getSaveData();
                            const name = getCardTitle(data);

                            //保存到doc
                            editDoc((data.id || LASTEST_NOTE_DOC),data.doc,data.name).then(res=>{
                              setTimeout(() => {
                                ipcSend('save-pdf-to-system', (data.id || LASTEST_NOTE_DOC), name)
                              }, 10);
                            })
                          }else if (szId == 'exportMarkdown'){
                            markdown();
                          }
                          else {
                            const newData = await editorRef.current?.save?.();
                            shareCardData(newData,null,dialogPublishToWebRef);
                          }
                        });
                      }} src={getImagePathWithThemeSvg('share_card')}/>
                    </Tooltip>

                    <Dropdown trigger={['click']} open={isShowMenuMore} onOpenChange={(e)=>{
                      setIsShowMenuMore(e);
                      patchMenuFavor();
                    }}  menu={{items: MENU_MORE()}} overlayStyle={{minWidth: '168px',zIndex:'999999'}}
                              align={{offset: [-156, 10]}}>
                      <img className={'img-32 hovered-gray-radius ml-4'} src={getImagePathWithTheme('dialog_card_new_more.svg')}/>
                    </Dropdown>

                    <div className={'img-32 flex-center ml-4'} onClick={(event)=>{
                       window.closeDialogCard(data);
                    }}>
                      <img className={'img-32 hovered-gray-radius'}
                           src={imgPathPerfix() + (isDarkMode() ? "dialog_card_new_close_white.svg" : "dialog_card_new_close.svg")}/>
                    </div>
                  </div>
              }
            </div>
        }
        <div id='div-note-container' className={style.NewNote + ' ' + (isPdfAtom ? style.pdf : null) + ' ' + (fullScreen ? null : style.modal)} onMouseDown={(e)=>{
          //取消选中。。。
          // 将选择范围设置为空（光标位置保持不变）

        }}>
          {
              fullScreen &&
              <TitleBar title={t("AppName")} isDark={true} fromPage={'noteV2'}/>
          }


          {/*全屏的右上角*/}
          <header className={style.header + ` ${isInSingleFloatWindow()?'drag':''}`} style={{top:isInSingleFloatWindow()?'0px':'30px'}}>
            {
              isInSingleFloatWindow()?<>
                    <div className={'flex-row-vertical-center'} style={{width:'100%'}} onMouseDown={(event)=>{
                      event.preventDefault();
                      event.stopPropagation();
                    }} onClick={(event)=>{
                      editorRef.current?.onEditorFocus();
                    }}>
                      <span className={'dialog-title ml-14 drag'} style={{flexGrow:'1',fontFamily:'PoppinsSemiBold'}}>Noteey</span>
                      <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                        <Tooltip arrow={false} title={t('Settings')}>
                          <img className={'img-25 cursor-pointer'} style={{cursor: 'pointer'}}
                               src={getImagePathWithThemeSvg('float_card_set')} onClick={async (event) => {
                            event.stopPropagation();
                            ipcInvoke('float-card-set');
                          }}/>
                        </Tooltip>

                        <Tooltip arrow={false} open={isOpenSaveTooltip} onOpenChange={(e)=>{
                          // if (isSaveEnable) {
                          //   setIsOpenSaveTooltip(e);
                          // }else {
                          //   setIsOpenSaveTooltip(false);
                          // }
                          setIsOpenSaveTooltip(e);
                        }} title={t('SaveToLibrary')}>
                          <img className={'img-25 ml-8'} style={{cursor: isSaveEnable ? 'pointer' : 'default'}}
                               src={getImagePathWithThemeSvg(isSaveEnable?'card_save_enabled':'card_save_gray')} onClick={async (event) => {
                            event.stopPropagation();
                            if (isSaveEnable) {
                              let szQuickNoteConfig = localStorage.getItem(KEY_QUICKNOTE_CONFIG);
                              let jsonQuickNoteConfig = null;
                              if (szQuickNoteConfig){
                                jsonQuickNoteConfig = JSON.parse(szQuickNoteConfig);
                              }

                              //保存-----floatwindow card.....保存...保存...保存...保存...保存
                              //清空这个ID的，复制为一个新的ID，保存，然后通知主界面更新...
                              const oldData = {...editorRef.current?.getSaveData()};

                              const newData = {...oldData};
                              newData.id = generateUUID2();
                              newData.isDeleted = 0;
                              newData.createTime = newData.updateTime = newData.updateTime1 = Date.now();//按当前时间来算.
                              if (isArray(jsonQuickNoteConfig?.defaultTags)){
                                newData.tags = jsonQuickNoteConfig?.defaultTags;
                              }
                              await updateCard(newData);

                              //添加到项目下....
                              if (jsonQuickNoteConfig?.defaultProject){
                                const project = await getProjectById(jsonQuickNoteConfig.defaultProject?.id);
                                if (project){
                                  project.key = jsonQuickNoteConfig.defaultProject?.key;
                                  window.insertItemsToProject(project,[newData],false);
                                  ipcInvoke('notify-main-draw-insert', {projectId:jsonQuickNoteConfig.defaultProject.id,libraryId:newData.id})
                                }
                              }

                              //清空当前这个.-并保存到数据库
                              const newOldData = {...oldData};
                              newOldData.doc = newOldData.html = newOldData.thumbHtml = '';
                              newOldData.tags = [];
                              await updateCard(newOldData,true,true,'',true);
                              setData(newOldData);

                              message.info(t('SavedToLibrary'));

                              //通知主界面更新一把...
                              ipcInvoke('notify-main-library-update');
                            }
                          }}/>
                        </Tooltip>

                        <img className={'img-25 ml-8 cursor-pointer'}
                             onClick={(event) => {
                               event.stopPropagation();
                               ipcInvoke('close-float-card-win')
                             }}
                             src={getImagePathWithThemeSvg('card_single_win_close')}/>
                      </div>
                    </div>
                  </> ://下面是正常窗口的菜单栏
                  <>
                    <div className='flex-row-vertical-center'>
                      {/* <RollbackOutlined onClick={() => navigate(-1)} /> */}
                      {/*<OffScreenOne theme="outline" size="20" fill="#333" onClick={() => setFullScreen(false)}/>*/}
                      <img style={{width: '32px', height: '32px'}} src={getImagePathWithTheme(isSaveEnable?'':'note_exit_full_screen')}
                           onClick={() => {
                             setFullScreen(false);
                             if (global.g_isCurrentNoteFullScreenInCanvas) {
                               global.g_isCurrentNoteFullScreenInCanvas = false;
                               save();
                             }
                             window.GSearchClose?.()
                           }}
                           className='title-icon img-medium-small cursor-pointer'/>

                    </div>

                    {
                        !isPresentMode &&
                        <div className={'flex-row-vertical-center'}>
                          <div className='flex-row-vertical-center'>
                            {/*<Button icon={<IconDelete/>} onClick={() => save(false, false)}></Button>*/}
                            {/*<img style={{width: '32px', height: '32px'}} onClick={() => save(false, false)} src={getImagePathWithTheme('note_save')}*/}
                            {/*     className='title-icon img-medium-small cursor-pointer ml-8'/>*/}
                            {/*<Share getSaveData={getSaveData}/>*/}
                          </div>
                          <Dropdown trigger={['click']} open={isShowMenuMore1} onOpenChange={(e)=>{
                            setIsShowMenuMore1(e);
                            patchMenuFavor();
                          }} menu={{items: MENU_MORE()}}>
                            <img src={getImagePathWithTheme('vertical_more_gary')}
                                 className='img-16 title-icon img-medium-small cursor-pointer ml-8'/>
                          </Dropdown>
                        </div>
                    }
                  </>
            }
          </header>

          <div className={style.wrap} style={{display: 'flex',paddingTop:isInSingleFloatWindow()?'36px':'0px'}}>
            <div style={{
              position: 'relative', /*minWidth: `${headerTreeWidth}px`,*/
              overflow: 'hidden',
              width: '320px',
              display: sideBarStatus == 2 ? 'inherit' : 'none'
            }}>
              {
                  editor &&
                  <SideBarFold ref={sideBarFoldRef} editor={editor} from={FROM_DIALOG} data={data}
                               onCollapseCallback={(sidebarStatus: any) => {
                                 setSideBarStatus(sidebarStatus)
                               }}/>
              }
            </div>

            <div className={'tiptap-outer-sider-div-for-test-click'} style={{
              paddingLeft: fullScreen ? getFullscreenEditorLRPadding() : getEditorLRPadding(),
              paddingRight: fullScreen ? getFullscreenEditorLRPadding() : getEditorLRPadding(),
              overflowX: 'hidden',
              overflowY: 'auto',
              height: '100%',
              width: '100%'
            }} onMouseDown={(e)=>{
              if (mEditorRef.current && e.target?.classList?.contains('tiptap-outer-sider-div-for-test-click')){
                mEditorRef.current.chain().focus().setTextSelection(mEditorRef.current.state.selection.from).run();
                // mEditorRef.current.commands.blur();
              }
            }}>

              {/*<div className={style.box} id="EDITOR_SCROLL_BOX">*/}
              {/*  <Editor ref={editorRef} data={data}/>*/}
              {/*</div>*/}
              <Editor ref={editorRef} data={data} onInitComplete={(editor) => {
                mEditorRef.current = editor;
                setEditor(editor);
              }} onEmptyData={()=>{
                setIsSaveEnable(false)
              }} onUpdate={(data:any)=>{
                //更新...判断是否有空.
                if (isCardEmpty(data.doc)) {
                  setIsSaveEnable(false)
                }else {
                  setIsSaveEnable(true);
                }
              }}/>
            </div>

          </div>
        </div>

      </>
  );
})

export default NewNote;



































